import service from '@/store/services/settings/contribution-service';
import contributionItems from '@/store/services/settings/contribution-item-service';

const state = {
    list: {},
    contribution: {},
    contributionItem: {},
    meta: {}
};

const mutations = {
    SET_LIST: (state, list) => {
        state.list = list;
    },
    SET_RESOURCE: (state, contribution) => {
        state.contribution = contribution;
    },
    SET_META: (state, meta) => {
        state.meta = meta;
    }

};

const actions = {
    list ({ commit, dispatch }, params = {}) {
        return service.list(params)
            .then(({ list, meta }) => {
                commit('SET_LIST', list);
                commit('SET_META', meta);
            });
    },
    activities ({ commit, dispatch }, params) {
        return service.activities(params)
            .then(({ list, meta }) => {
                commit('SET_LIST', list);
                commit('SET_META', meta);
            });
    },

    get ({ commit, dispatch }, params) {
        return service.get(params)
            .then(contribution => {
                commit('SET_RESOURCE', contribution);
            });
    },
    rates ({ commit, dispatch }, params) {
        return contributionItems.list(params)
            .then(contributionItem => {
                commit('SET_RESOURCE', contributionItem);
            });
    },
    show ({ commit, dispatch }, params) {
        return service.show(params)
            .then(contribution => {
                commit('SET_RESOURCE', contribution);
            });
    },
    add ({ commit, dispatch }, params) {
        return service.add(params)
            .then((contribution) => {
                commit('SET_RESOURCE', contribution);
            });
    },

    update ({ commit, dispatch }, params) {
        return service.update(params)
            .then((contribution) => {
                commit('SET_RESOURCE', contribution);
            });
    },

    destroy ({ commit, dispatch }, params) {
        return service.destroy(params);
    },
};

const getters = {
    list: state => state.list,
    listTotal: state => state.meta.page.total,
    contribution: state => state.contribution,
    contributionItem: state=> state.contribution.contributionItem,
    dropdown: (state) => {
        return state.list.map(contribution => ({
            id: contribution.id,
            name: contribution.name
        }));
    }
};

const contributions = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default contributions;
